import {DeliveryStatus} from "./dataForActiveCampaign";

export interface CampaignStatistic {
    name: string,
    dob: string,
    gender: string,
    email: string,
    phone: string,
    lastVisit: string,
    deliveryStatus: DeliveryStatus,
    deliverTime: string,
}

export interface CampaignStatisticDetail {
    list: Array<CampaignStatistic>,
    totalCount: number,
    successCount: number,
    failCount: number,
    pendingCount: number,
}

export const DefaultCampaignStatisticDetail: CampaignStatisticDetail = {
    list: [],
    totalCount: 0,
    successCount: 0,
    failCount: 0,
    pendingCount: 0,
}
